import { render, staticRenderFns } from "./otellistesi.vue?vue&type=template&id=10c00042&"
import script from "./otellistesi.vue?vue&type=script&lang=js&"
export * from "./otellistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports